<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td><router-link
          :to="{name: 'account-emv-tap-details', params: {id: details.account_id, resource_id: details.id}}">
        {{ details.id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.journey_id') }}</label></td>
      <td>
        <router-link
          :to="{name: 'account-journey-details', params: {id: details.account_id, journey_id: details.journey_id}}">
          {{ details.journey_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.tap_id') }}</label></td>
      <td>
        <router-link
          :to="{name: 'account-tap-details', params: {id: details.account_id, resource_id: details.tap_id}}">
          {{ details.tap_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.type') }}</label></td>
      <td>{{ details.type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.account_id') }}</label></td>
      <td>
        <router-link
          :to="{name: 'account-emv-taps', params: {id: details.account_id}}">
          {{ details.account_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.request_id') }}</label></td>
      <td>{{ details.request_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.card_token') }}</label></td>
      <td>{{ details.card_token }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.masked_pan') }}</label></td>
      <td>{{ details.masked_pan }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.metadata') }}</label></td>
      <td><meta-data-details :data="details.metadata"/></td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.emv_external_tap_id') }}</label></td>
      <td>
        <router-link v-if="details.emv_external_tap_id"
          :to="{name: 'externalEmvTap', params: {id: details.emv_external_tap_id}}">
          {{ details.emv_external_tap_id }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.linked_at') }}</label></td>
      <td>{{ details.linked_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.business_day') }}</label></td>
      <td>{{ details.business_day | dateOnly }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.clearing_attempt') }}</label></td>
      <td>{{ details.clearing_attempt }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emvTap.details.applied_at') }}</label></td>
      <td>{{ details.applied_at | time }}</td>
    </tr>
  </table>
</template>
<script>
import MetaDataDetails from "@/components/MetaData/MetaDataDetails.vue";

export default {
  name: 'EmvTapDetails',
  components: {
    MetaDataDetails
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style></style>
